import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-284" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: "0px",
      paddingBottom: "14px"
    }} data-id="element-285" data-mp="18228gsl3fjf4">
        <div className="text-center" data-id="element-286" data-mp="1zv1nfblkz7nh">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-287" data-mp="1zw4d5g76341t">
            

          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-288" data-mp="24susu2f27xmp">
            📚 Your 6-volume AI-powered proposal system
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-289" data-mp="1vt7nx6n4g9ow">
            This is more than a collection of generic AI prompts. It's an organized workflow designed to help you move from
            an initial client inquiry to a structured proposal and a clearer project handoff.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-290" data-mp="3o7ddp5lwosnt">
            {pillars.map(p => <span key={p} className="rounded-full border border-plum/15 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum" data-id="element-291" data-mp="3j9ll09dft2ik">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-292" data-mp="3t685gx1uprk2">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-plum/10 bg-white p-5" data-id="element-293" data-mp="b0v4j845se61" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-294" data-mp="fupmo7448l30">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-grape-soft" data-id="element-295" data-mp="tsxpgvnu2gm3">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="min-w-0 text-sm font-black uppercase leading-tight text-plum" data-id="element-296" data-mp="wrmpnpoa6rls">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-297" data-mp="16rx5li1pad4n">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/30 bg-white p-6 shadow-[0_0_0_4px_rgba(0,112,255,0.05)]" data-id="element-298" data-mp="1bivmaiqlpd8f">
          <p className="text-center font-display text-lg font-black text-plum" data-id="element-299" data-mp="1fjfk7oj00kvm">✅ Every volume includes:</p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-300" data-mp="1khqrpsltmjao">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-301" data-mp="1pjpxf9519sas">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-302" data-mp="1uhrddl75xbi1" />
                {item}
              </li>)}
          </ul>
          <p className="mt-5 border-t border-plum/10 pt-4 text-center text-sm font-semibold text-grape-deep" data-id="element-303" data-mp="3rbuo6hasqjjx">
            A structured way to turn AI into a practical assistant for your freelance proposal workflow.
          </p>
        </div>
      </div>
    </section>;
}